import axiosInstance from './api';

const getErrorMessage = (error, fallback) => error?.message || error?.error?.message || fallback;

/** GET /admin/partner-dashboard */
export const getPartnerDashboard = async () => {
  try {
    const response = await axiosInstance.get('/admin/partner-dashboard');
    return {
      success: true,
      data: response.data?.data ?? {},
    };
  } catch (error) {
    return {
      success: false,
      message: getErrorMessage(error, 'Failed to load partner dashboard'),
      error,
    };
  }
};
